import Vue from 'vue';
import VueRouter from 'vue-router';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

/**
 * routes 里面的 meta 在 homepage 里面的面包屑使用
 */

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../pages/Home.vue'),
    children: [
      {
        path: 'sheetA',
        name: 'sheetA',
        component: () => import('../pages/surveySheet/index.vue'),
      },
      {
        path: 'sheetB',
        name: 'sheetB',
        component: () => import('../pages/surveySheet/indexB.vue'),
      },
      // {
      //   path: 'sheetC',
      //   name: 'sheetC',
      //   component: () => import('../pages/surveySheet/indexC.vue'),
      // },
      // {
      //   path: 'sheetD',
      //   name: 'sheetD',
      //   component: () => import('../pages/surveySheet/indexD.vue'),
      // },
      // 登录模块
      {
        path: '/',
        meta: {},
        component: () => import('../pages/loginPages/loginPage'),
      },
      {
        path: '/registerPage',
        meta: {},
        component: () => import('../pages/loginPages/registerPage'),
      },
      {
        path: '/homePage',
        name: '工作台',
        component: () => import('../pages/homePage.vue'),
        children: [
          // 账号信息&注册审批
          {
            path: '/accountPages/accountCenter',
            name: 'accountCenter',
            component: () => import('../pages/accountPages/account/accountCenter.vue'),
          },
          {
            path: '/accountPages/accountManage',
            name: 'accountManage',
            component: () => import('../pages/accountPages/account/accountManage.vue'),
          },
          {
            path: '/accountPages/detail_accountManage',
            name: 'detail_accountManage',
            component: () => import('../pages/accountPages/account/detail_accountManage.vue'),
          },
          // 用户数据分析（静态页面）
          {
            path: '/accountPages/dataAnalysis',
            name: 'dataAnalysis_account',
            component: () => import('../pages/accountPages/dataAnalysis.vue'),
          },
          // 专家库
          {
            path: '/accountPages/expertManage',
            name: 'expertManage',
            component: () => import('../pages/accountPages/expert/expertManage.vue'),
          },
          {
            path: '/accountPages/edit_expert',
            name: 'edit_expert',
            component: () => import('../pages/accountPages/expert/edit.vue'),
          },
          {
            path: '/accountPages/detail_expert',
            name: 'detail_expert',
            component: () => import('../pages/accountPages/expert/detail.vue'),
          },
          // 用户组织(等级用户)管理
          {
            path: '/accountPages/orgManage',
            name: 'orgManage',
            component: () => import('../pages/accountPages/orgManage/orgManage.vue'),
          },
          {
            path: '/accountPages/edit_org',
            name: 'edit_org',
            component: () => import('../pages/accountPages/orgManage/edit.vue'),
          },
          {
            path: '/accountPages/detail_org',
            name: 'detail_org',
            component: () => import('../pages/accountPages/orgManage/detail.vue'),
          },
          // 行业分类管理
          {
            path: '/tradeManage',
            name: 'tradeManage',
            component: () => import('../pages/tradeManage/tradeManage.vue'),
          },
          {
            path: '/tradeManage/edit',
            name: 'edit_trade',
            component: () => import('../pages/tradeManage/edit.vue'),
          },
          {
            path: '/tradeManage/detail',
            name: 'detail_trade',
            component: () => import('../pages/tradeManage/detail.vue'),
          },
          // 行业数据分析（静态页面）
          {
            path: '/tradeManage/dataAnalysis',
            name: 'dataAnalysis_trade',
            component: () => import('../pages/tradeManage/dataAnalysis.vue'),
          },
          // 题库管理
          {
            path: '/questionBank',
            name: 'questionBank',
            component: () => import('../pages/questionBank/index.vue'),
          },
          // 评审细则管理
          {
            path: '/testPaper',
            name: 'testPaper',
            component: () => import('../pages/testPaper/index.vue'),
          },
          {
            // 新增 / 编辑评审细则
            path: '/editTestPaper',
            name: 'editTestPaper',
            component: () => import('../pages/testPaper/editTestPaper.vue'),
          },
          // 自评评审管理
          {
            path: '/selfAssess',
            name: 'selfAssess',
            component: () => import('../pages/selfAssess/index.vue'),
          },
          // 发起自评
          {
            path: '/initiaSelf',
            name: 'initiaSelf',
            component: () => import('../pages/selfAssess/InitiaSelf.vue'),
          },
          // 自评详情
          {
            path: '/selfDeil',
            name: 'selfDeil',
            component: () => import('../pages/selfAssess/deil.vue'),
          },
          // 专家评审管理
          {
            path: '/expertAssess',
            name: 'expertAssess',
            component: () => import('../pages/expertAssess/index.vue'),
          },
          // 专家发起专家评审
          {
            path: '/initiaExpert',
            name: 'initiaExpert',
            component: () => import('../pages/expertAssess/InitiaExpert.vue'),
          },
          // 专家评详情
          {
            path: '/expertDeil',
            name: 'expertDeil',
            component: () => import('../pages/expertAssess/deil.vue'),
          },
          // 专家评审提交预览
          {
            path: '/Preview',
            name: 'Preview',
            component: () => import('../pages/expertAssess/Preview.vue'),
          },

          // 评审管理
          {
            path: '/reviewManagement',
            name: 'reviewManagement',
            component: () => import('../pages/reviewManagement/reviewManagement.vue'),
          },
          {
            path: '/detail_reviewManagement',
            name: 'detail_reviewManagement',
            component: () => import('../pages/reviewManagement/detail.vue'),
          },
          {
            path: '/edit_reviewManagement',
            name: 'edit_reviewManagement',
            component: () => import('../pages/reviewManagement/edit.vue'),
          },
          {
            path: '/detail_simple',
            name: 'detail_simple',
            component: () => import('../pages/reviewManagement/detail_simple.vue'),
          },
          // 分配专家
          {
            path: '/distributionSpecialist',
            name: 'distributionSpecialist',
            component: () => import('../pages/reviewManagement/distributionSpecialist.vue'),
          },

          {
            path: '/404',
            name: '404',
            component: () => import('../components/404.vue'),
            children: [],
          },
        ],
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
// 导航守卫，用于修改标题
router.beforeEach((to, from, next) => {
  if (to.path == '/sheetA' || to.path == '/sheetB') {
    document.title = '工业互联网领域产业人才现状调研表';
  } else {
    document.title = '设备管理成熟度评估系统';
  }
  next();
});
export default router;
